<template>
  <div class="okrItem" v-if="item">
    <b-container class="objective objective-text current-obj" @click="setObj(item)" v-bind:class="{'hilight': hilight || (hilightByKeyresult && targetItem == ''), 'targetHilight': targetMode}">
      <b-row class="okrkeyreuslt">
        <b-col v-on:mouseover="onMouseOver('objectives',itemId)" v-on:mouseleave="onMouseLeave('objectives')" @click="onClickOkr()" @dblclick="onDblClickOkr(itemId)">
        <div class="objective-detail">
          <objective :page="'okrTree'" :itemId="itemId" :detailView="true" :content="this.item.contentText" :progress="this.item.progress ? '' + this.item.progress : '0'" :setReadOnly="'false'" :objective="false" />
        </div>
      <div class="under">
        <div class="expandUserImages pt-2">
          <img v-for="(imageURL,index) of userImages" 
            :key="index" 
            class="img-circle" 
            v-bind:style="{zIndex: (5-Number(index)), left: (index+1)*5+'px'}" 
            style="position: absolute;"
            :src="imageURL">
        </div>
        <div class="date">
          <div class="text-center small pt-2">
            <label class="mb-0">{{ $t('startDateStr') }}：</label>
            <span>{{item.startDate}}</span>
          </div>
          <div class="text-center small pt-2">
            <label class="mb-0">{{ $t('dueDateStr') }}：</label>
            <span>{{ item.dueDate }}</span>
          </div>
        </div>
      </div>
      <hr v-if="item.keyresults" class="m-0">
      </b-col>
      <div class="keyresults" v-if="item.hasOwnProperty('keyresults')">
        <b-col v-for="(krId, index) in Object.keys(item.keyresults)" v-bind:key="krId" v-bind:class="{keyItem: checkKeyresult(item.keyresults, index), 'hilight': targetItem === krId, 'targetHilight': targetMode}" v-on:mouseover="onMouseOver('keyresults',krId)" v-on:mouseleave="onMouseLeave('keyresults')"
        @click="onClickOkr()" @dblclick="onDblClickOkr(krId)">
          <div class="objective-detail">
            <objective :page="'report'" :itemId="krId" :detailView="true" :content="getKeyresult[krId].contentText" :progress="getKeyresult[krId].progress ? '' + getKeyresult[krId].progress : '0'" :setReadOnly="'false'" :objective="false" />
          </div>
          <div class="text-center small pt-2">
            <label class="mb-0">{{ $t('startDateStr') }}：</label>
            <span>{{getKeyresult[krId].startDate}}</span>
          </div>
            <div class="text-center small pt-2">
              <label class="mb-0">{{ $t('dueDateStr') }}：</label>
              <span>{{ getKeyresult[krId].dueDate }}</span>
            </div>
        </b-col>
      </div>
      </b-row>
    </b-container>
    <!-- <template v-for="(kr, krId) in item.keyresults">
      <b-container v-if="!!getKeyresult[krId]" class="keyresult" :key="krId" @click="setKr(getKeyresult[krId])" :class="{ selected: (krId == selectedKey) }">
          <div class="objective-detail">
            <objective :page="'report'" :itemId="krId" :detailView="true" :content="getKeyresult[krId].contentText" :progress="getKeyresult[krId].progress ? '' + getKeyresult[krId].progress : '0'" :setReadOnly="'false'" :objective="false" />
          </div>
        <div class="text-center small pt-2">
          <label class="mb-0">{{ $t('startDateStr') }}：</label>
          <span>{{getKeyresult[krId].startDate}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-end">
          <div class="text-center small pt-2">
            <label class="mb-0">{{ $t('dueDateStr') }}：</label>
            <span>{{ getKeyresult[krId].dueDate }}</span>
          </div>
        </div>
      </b-container>
    </template> -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Objective from '@/components/Okr/Objective'
import ObjectiveKnob from '@/components/Okr/ObjectiveKnob'

export default {
  name: 'OkrTreeItem',
  components: {
    // moment,
    Objective,
    ObjectiveKnob
  },
  props: ['item', 'selectedKey', 'fromDate', 'toDate', 'searchType', 'itemId', 'itemType', 'userId', 'hilight', 'targetMode', 'hilightByKeyresult', 'targetType', 'targetItem'],
  data: function () {
    return {
      scrolling: false
    }
  },
  getters: {
  },
  computed: {
    ...mapGetters([
      // 'getKeyresultsByUser'
      'getUserId'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByUserId'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    getKeyresult () {
      return this.getKeyresultsByUserId(this.userId, true, true)
    },
    userImages () {
      if (this.item.hasOwnProperty('sharedOwners')) {
        const images = Object.keys(this.item.sharedOwners)
          .map(x => !!this.getUserInfoById(x) && this.getUserInfoById(x).hasOwnProperty('userIcon') ? this.getUserInfoById(x).userIcon : 'static/img/noImage.png')
        return images.length > 0 ? images : ['static/img/noImage.png']
      } else {
        const userId = this.userId
        if (!!this.getUserInfoById(userId) && this.getUserInfoById(userId).hasOwnProperty('userIcon')) {
          return [this.getUserInfoById(userId).userIcon]
        } else {
          return ['static/img/noImage.png']
        }
      }
    }
  },
  created: function () {
  },
  updated: function () {
    // this.scrollToSelected()
  },
  mounted: function () {
  },
  watch: {
  },
  methods: {
    setObj (val) {
      console.log('setObj: ', val)
      this.$emit('set-item', val)
    },
    onDblClickOkr: function (target) {
      let data = {userId: this.userId, itemId: target}
      this.$emit('onDblClick', data)
    },
    onClickOkr: function () {
      let data = {userId: this.userId, itemId: this.itemId}
      this.$emit('onClick', data)
    },
    onMouseOver: function (target, targetId) {
      if (target === 'objective') {
        targetId = this.temId
      }
      let data = {userId: this.userId, itemId: this.itemId, target: target, targetId: targetId}
      this.$emit('onMouseOver', data)
    },
    onMouseLeave: function (target) {
      let data = {userId: this.userId, itemId: this.itemId, targetType: target}
      this.$emit('onMouseLeave', data)
    },
    setKr (val) {
      console.log('setKr: ', val)
      this.$emit('set-item', val)
    },
    checkKeyresult: function (krs, index) {
      return !((Object.keys(krs).length - 1) === index)
    }
  },
  filters: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a:hover{
  text-decoration: none;
}
.okrItem {
  flex: 0 0 80px;
  transition: .2s;
  // display: flex;
  width: 100%;
  display: -webkit-box;
  // font-size: 75%;
  // .keyresult.container {
  //   margin: 1em auto;
  // }
  .container {
    padding: 0;
    // margin: 1em auto;
    cursor: pointer;
    transition: .2s;
    position: relative;
    .btn-open-detail {
      display: none;
      position: absolute;
      // top: 24px;
      // right: 1.2em;
      bottom: 1.5em;
    }
    &:hover {
      transition: .2s;
      .btn-open-detail {
        display: block;
        &:not(:hover) {
          background-color: rgba(255,255,255,.7)
        }
      }
    }
  }
  .objective {
    background: white;
    width: 100%;
    // width: 200px;
    // box-shadow: 0 0 .1em .3em transparent;
    // &:hover {
    //   box-shadow: 0 0 .1em .3em #333399;
    // }
    border: 1px solid;
  }
  .keyresult {
    width: 200px;
    background: white;
    // width: 200px;
    // &:hover {
    //   box-shadow: 0 0 .1em .3em #6666ff;
    // }
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .btn-open-detail {
      bottom: 2.1em;
    }
    border: 1px solid;
  }
  .selected {
    box-shadow: 0 0 .1em .3em #ccccFF;
    box-shadow: 0 0 .1em .3em transparent;
  }
  .objective-text {
    margin-left: 0;
    .content-text {
      margin-bottom: 0;
    }
  }
  .content-text {
    padding-left: .25em;
    padding-right: .25em;
    text-align: center;
    background: transparent;
    font-size: 90%;
  }
  .item-bottom {
    margin-top: 0.5em;
    border-top: 1px dotted rgba(0, 0, 0, 0.1);
  }
  .objective-detail{
    margin: 0 15px;
    width: 100%;
  }
  .current-obj {
  }
  .keyresults {
    display: flex;
    .col {
      margin: 10px;
      max-width: 200px;
    }
  }
  .okrkeyreuslt {
    display: contents;
  }
  .keyItem {
    border-right: 0.1px solid;
    border-right-color: rgb(221, 210, 210);
  }
  .img-circle{
  width: 40px;
  height: 40px;
  position: relative;
  top: 10px;
  right: -5px;
  left: 3px;
  border: 0.2px solid rgba(0, 0, 0, 0.5);
  }

  .expandUserImages {
  left: 15px;
  top: -10px;
  }
  .hilight {
   outline-width: 10px;
   outline-style: solid;
   outline-color: skyblue;
  }
  .targetHilight {
   outline-color: #f5b247;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/OkrTreeItem.vue